'use client';

import { c as _c } from "react/compiler-runtime";
import { Button } from '@common/components';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useShallow } from 'zustand/react/shallow';
import { AuthApi, AuthQueryKey, TERM_CATEGORY } from '@/api';
import { ResponsiveDialog } from '@/components/organism/ResponsiveDialog';
import { useGlobalStore } from '@/stores/GlobalStore';
export const LocationServiceConsentDrawer = () => {
  const $ = _c(24);
  const [handleLocationServiceConsentDrawer, setHandleLocationServiceConsentDrawer, setTermsDrawerType] = useGlobalStore(useShallow(_temp));
  const isLocationServiceConsentDrawerOpened = !!handleLocationServiceConsentDrawer;
  const queryClient = useQueryClient();
  let t0;
  if ($[0] !== handleLocationServiceConsentDrawer || $[1] !== queryClient || $[2] !== setHandleLocationServiceConsentDrawer) {
    t0 = {
      mutationFn: _temp2,
      onSuccess: async (_, isAgree_0) => {
        await queryClient.invalidateQueries({
          queryKey: AuthQueryKey["get:/wello/v2/auth/member-wello/location-service-consent"]()
        });
        await handleLocationServiceConsentDrawer?.(isAgree_0);
        setHandleLocationServiceConsentDrawer(undefined);
      }
    };
    $[0] = handleLocationServiceConsentDrawer;
    $[1] = queryClient;
    $[2] = setHandleLocationServiceConsentDrawer;
    $[3] = t0;
  } else {
    t0 = $[3];
  }
  const updateLocationServiceConsentMutation = useMutation(t0);
  let t1;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <h3 className="mb-8 text-Gray-900 typo-body2">위치기반서비스 이용약관에 동의해주세요</h3>;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  let t2;
  if ($[5] !== setTermsDrawerType) {
    t2 = <p className="font-400 text-Gray-700 typo-body4">현재 위치 정보 확인을 위해 위치기반서비스 이용약관 동의가 필요합니다.<button className="ml-8 font-600 text-Gray-black underline" type="button" onClick={() => setTermsDrawerType(TERM_CATEGORY.LOCATION_POLICY_SELECT)}>보기</button></p>;
    $[5] = setTermsDrawerType;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  let t3;
  if ($[7] !== updateLocationServiceConsentMutation) {
    t3 = () => {
      updateLocationServiceConsentMutation.mutate(false);
    };
    $[7] = updateLocationServiceConsentMutation;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  let t4;
  if ($[9] !== t3 || $[10] !== updateLocationServiceConsentMutation.isPending) {
    t4 = <Button className="min-w-120" loading={updateLocationServiceConsentMutation.isPending} theme="sub-line" onClick={t3}>동의안함</Button>;
    $[9] = t3;
    $[10] = updateLocationServiceConsentMutation.isPending;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  let t5;
  if ($[12] !== updateLocationServiceConsentMutation) {
    t5 = () => {
      updateLocationServiceConsentMutation.mutate(true);
    };
    $[12] = updateLocationServiceConsentMutation;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  let t6;
  if ($[14] !== t5 || $[15] !== updateLocationServiceConsentMutation.isPending) {
    t6 = <Button className="flex-1" loading={updateLocationServiceConsentMutation.isPending} onClick={t5}>동의함</Button>;
    $[14] = t5;
    $[15] = updateLocationServiceConsentMutation.isPending;
    $[16] = t6;
  } else {
    t6 = $[16];
  }
  let t7;
  if ($[17] !== t4 || $[18] !== t6) {
    t7 = <footer className="mt-28 flex gap-8">{t4}{t6}</footer>;
    $[17] = t4;
    $[18] = t6;
    $[19] = t7;
  } else {
    t7 = $[19];
  }
  let t8;
  if ($[20] !== isLocationServiceConsentDrawerOpened || $[21] !== t2 || $[22] !== t7) {
    t8 = <ResponsiveDialog opened={isLocationServiceConsentDrawerOpened} drawerType="bottom">{t1}{t2}{t7}</ResponsiveDialog>;
    $[20] = isLocationServiceConsentDrawerOpened;
    $[21] = t2;
    $[22] = t7;
    $[23] = t8;
  } else {
    t8 = $[23];
  }
  return t8;
};
function _temp(state) {
  return [state.handleLocationServiceConsentDrawer, state.setHandleLocationServiceConsentDrawer, state.setTermsDrawerType];
}
function _temp2(isAgree) {
  return AuthApi["put:/wello/v2/auth/member-wello/location-service-consent"]({
    body: {
      locationServiceConsentYN: isAgree
    }
  });
}